
export default {
   
  data() {
    return {
      error:""
    };
  },
  mounted() {
  
  },

  computed: {
    isValid(){
     
      let valid=true
      for(var v in this.validation){
        valid=valid && this.check(this.validation[v])
      }
      return valid || this.overriden
    }
    
  },
  methods: {
    check(type){
      let  valid=true

      this.error=""
      if(this.overriden){
        return
      }
       switch(type){
         case "notEmpty":
             if(this.search==""){
               valid=false
               this.error="*required"
             }
           break
           case "inList":
             if(this.arrMatch(this.items,this.search)==undefined){
               valid=false
               if(this.showAdd){
                this.error="New Item add to list"
               }else{
                this.error="Choose from List"
               }
               
             }
           break
           case "unique":
             if(this.arrMatch(this.items,this.search)!==undefined){
             //if(this.items.includes(this.search)){
               valid=false
               this.error="Select a unique name"
             }
           break
       }
       return valid
  },
  arrMatch(arr,str){
    const found = arr.find(element => {
      return element.toLowerCase() === str.toLowerCase();
    });
      return found
    },
    updateVal(){
      if(this.isValid){
        this.$emit("validate",this.search,this.field)
      }else{
        this.$emit("validate",null,this.field)
      }
    }
  
  },
  watch:{
    isValid(val){
      this.updateVal()
    }
  }
}
